export class Stack {
    tamanio = 0; 
    sp = 0; 
    lista = null; 

    constructor(tamanio, sp){
        this.tamanio = tamanio; 
        this.sp = sp; 
        this.lista = []; 
    }
    
}

